import React from 'react';
import {Technology} from "../../types/types";

type Props = {
    tags?: Technology[];
    scale: number;
    getTheme: (categories: number, filter: { [key: string]: boolean; }, x:any, y:any) => string;
    handleClick: (tag: Technology) => void;
    filter: { [key: string]: boolean; };
}

const RETURN_TYPES = {
    POSITION: "position",
    CLASS: "class"
};

const estimatedCharWidth = 10;

function getTagValue(tag: any, returnType: string) {
    let tagX = tag.x2021;

    // TODO: dynamically get container width from DOM
    const containerWidth = 1206;
    const textPixelWidth = tag.title.length * estimatedCharWidth;

    const isOutOfBound = (tagX / 102) * containerWidth + textPixelWidth > containerWidth;

    if (isOutOfBound) {
        if (returnType === RETURN_TYPES.POSITION) {
            // Adjust tagX so the tag does not go out of bounds
            tagX = (containerWidth - textPixelWidth) * 60 / containerWidth / 2;
            return tagX + 'px';
        } else if (returnType === RETURN_TYPES.CLASS) {
            return 'right-dot';
        }
    } else {
        if (returnType === RETURN_TYPES.CLASS) {
            return 'left-dot';
        } else {
            return;
        }
    }
}
function getTechnologyTagPositionBottom(tag: any) {
    return tag.y2021 + '%';
}

const TechnologyTag: React.FC<Props> = ({ tags, scale , getTheme, handleClick, filter}) => {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            {tags?.map((tag, index) => (
              <div
                    key={index}
                    className="technology-wrapper"
                    style={{
                        left: `${tag.x2021 ? tag.x2021 : 0}%`,
                        bottom: getTechnologyTagPositionBottom(tag),
                        transform: `scale(${1 / scale})`
                    }}
                >

                    <div className={`${getTagValue(tag, RETURN_TYPES.CLASS)} ${getTheme(tag.categories!, filter, tag.x2021, tag.y2021)}-dot`}></div>

                    <div
                        className={`technology-tag ${getTheme(tag.categories!, filter, tag.x2021, tag.y2021)}`}
                        onClick={() => handleClick(tag)}
                        style={{
                            right: getTagValue(tag, RETURN_TYPES.POSITION),
                            marginLeft: '15px'
                        }}
                    >
                        {tag.title}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TechnologyTag;